import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreUserProfileCustomProduct,
} from '../firestore/UserProfileCustomProduct/schema'

export class UserProfileCustomProduct extends ObservableModelWithDecorators<FirestoreUserProfileCustomProduct> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileCustomProduct>
  ) {
    super(repository, doc)
  }
}
